import $ from 'jquery';
import jQuery from 'jquery';
//import SCHError from 'SCHError';
//import Auth from '../auth/Auth';
//import {Globs} from '../Globs';

//v. 0.9.0


const CommonHelper = {

  pad0N(n) {
    return (n < 10) ? ('0' + n) : n;
  },

  convertTimeToFineString(dt){

    var strTimeSpent = '';

    var t = dt;
    var showSeconds = (t<60);

    var dt = 24*60*60;
    if(t >= dt){
      var n = (t - t%dt)/dt;
      strTimeSpent += n + ' day(s)';
      t-=n*dt;
    }

    dt = 60*60;
    if(t >= dt){
      var n = (t - t%dt)/dt;
      strTimeSpent += ' ' + this.pad0N(n) + 'h';
      t-=n*dt;
    }

    dt = 60;
    if(t >= dt){
      var n = (t - t%dt)/dt;
      strTimeSpent += ' ' + this.pad0N(n) + 'm';
      t-=n*dt;
    }

    if (showSeconds){
      strTimeSpent += ' ' + this.pad0N(t) + 's';
    }

    return strTimeSpent;
  },

  uppercaseFirstLetter(string) {
   return string.charAt(0).toUpperCase() + string.slice(1);
  },

  lowercaseFirstLetter(string) {
   return string.charAt(0).toLowerCase() + string.slice(1);
  },

  isNull(v) {
    return ( typeof(v) === 'undefined' || v === null);
  },
  isEmpty(v) {
    return ( typeof(v) === 'undefined' || v === null);
  },

  isNotEmpty(v) {
    return !( typeof(v) === 'undefined' || v === null);
  },
  removeLastDirectoryPartOf(url){

    if (CommonHelper.isNull(url) || typeof(url)!=='string') {
      return '';
    }else {
      var strUrl = '' + url;
      var arr = strUrl.split('/');
      arr.pop();
      return( arr.join('/') );
    }
  },

  getLastDirectoryPartOf(url){
    if (CommonHelper.isNull(url) || typeof(url)!=='string') {
      return '';
    }else {
      var strUrl = '' + url;
      var arr = strUrl.split('/');
      return arr.pop();
    }
  },

  //http://blog.bripkens.de/2011/06/html-javascript-calculate-text-dimensions/
  calculateWordDimensions(text, classes, escape) {
    classes = classes || [];

    if (escape === undefined) {
       escape = true;
    }

    classes.push('textDimensionCalculation');

    var div = document.createElement('div');
    div.setAttribute('class', classes.join(' '));

    if (escape) {
       $(div).text(text);
    } else {
       div.innerHTML = text;
    }

    document.body.appendChild(div);

    var dimensions = {
       width : jQuery(div).outerWidth(),
       height : jQuery(div).outerHeight()
    };

    div.parentNode.removeChild(div);

    return dimensions;
  },

  strInsert(str, index, value) {
      return str.substr(0, index) + value + str.substr(index);
  },

  strCutBetweenIndexes(str, idx0, idx1) {
    return str.substr(0, idx0) + str.substr(idx1);
  }

}

export default CommonHelper;
